import React, { type JSX } from "react";
import type { AdminDashboardDependencies } from "../../app/composition/create-admin-dashboard-dependencies";
import { pickAdminDashboardLocaleText } from "../../shared/locale/admin-dashboard-copy";
import { useAdminDashboardLocale } from "../../shared/locale/admin-dashboard-locale-context";
import { createOperationContextViewModel } from "./operation-context-view-model";

export type OperationContextScreenProps = {
  dependencies: AdminDashboardDependencies;
};

const cardStyle = {
  padding: "20px",
  borderRadius: "22px",
  background: "rgba(255, 255, 255, 0.82)",
  border: "1px solid rgba(24, 33, 43, 0.08)",
  boxShadow: "0 18px 36px rgba(15, 23, 42, 0.08)",
} as const;

export function OperationContextScreen(props: OperationContextScreenProps): JSX.Element {
  const { locale } = useAdminDashboardLocale();
  const viewModel = createOperationContextViewModel(props.dependencies, locale);
  const authModeLabel = pickAdminDashboardLocaleText(locale, { en: "Auth", ko: "인증" });
  const rolesLabel = pickAdminDashboardLocaleText(locale, { en: "Resolved roles", ko: "해결된 역할" });

  return (
    <section style={{ display: "grid", gap: "18px" }}>
      <header style={cardStyle}>
        <h2 style={{ margin: 0, fontSize: "1.5rem", letterSpacing: "-0.03em" }}>{viewModel.title}</h2>
      </header>

      <section style={cardStyle}>
        <dl style={{ display: "grid", gap: "14px", margin: 0 }}>
          {viewModel.runtimeItems.map((item) => (
            <div key={item.label} aria-label={`${item.label} ${item.value}`}>
              <dt style={{ color: "#64748b", fontSize: "0.88rem" }}>{item.label}</dt>
              <dd style={{ margin: "4px 0 0", color: "#18212b", fontWeight: 600 }}>{item.value}</dd>
            </div>
          ))}
          <div aria-label={`${authModeLabel} ${viewModel.authModeLabel}`}>
            <dt style={{ color: "#64748b", fontSize: "0.88rem" }}>{authModeLabel}</dt>
            <dd style={{ margin: "4px 0 0", color: "#18212b", fontWeight: 600 }}>{viewModel.authModeLabel}</dd>
          </div>
        </dl>
      </section>

      <section style={cardStyle}>
        <h3 style={{ margin: 0, fontSize: "1rem" }}>{rolesLabel}</h3>
        <ul style={{ display: "flex", flexWrap: "wrap", gap: "8px", margin: "12px 0 0", padding: 0, listStyle: "none" }}>
          {viewModel.roles.map((role) => (
            <li
              key={role}
              style={{ padding: "8px 12px", borderRadius: "999px", background: "rgba(24, 33, 43, 0.06)", fontWeight: 600 }}
            >
              {role}
            </li>
          ))}
        </ul>
      </section>
    </section>
  );
}
